// Accordion functionality for drawer menu
(function() {
  'use strict';

  function initDrawerAccordion() {
    const drawerMenu = document.querySelector('[data-drawer-menu]');
    if (!drawerMenu) {
      console.warn('Drawer accordion: No drawer menu found!');
      return;
    }

    console.log('Drawer accordion: Found drawer menu, attaching listeners...');

    // Intercept clicks on nested items and allow link navigation
    drawerMenu.addEventListener('click', function(e) {
      // Check if click is inside a nested list
      const nestedList = e.target.closest('.drawer-menu__list--nested');
      if (nestedList) {
        // Find the link that was clicked
        const link = e.target.closest('a[data-item="link"]');
        if (link) {
          console.log('Nested link clicked, navigating to:', link.href);
          // Stop propagation to prevent theme.js from interfering
          e.stopImmediatePropagation();
          // Allow default navigation
          return;
        }
      }

      // Check if this is a regular link at first level
      const regularLink = e.target.closest('a[data-item="link"]');
      if (regularLink && !e.target.closest('.drawer-menu__list--nested')) {
        console.log('First level link clicked:', regularLink.href);
        e.stopImmediatePropagation();
        return;
      }

      const accordionToggle = e.target.closest('[data-item="accordion-toggle"]');

      // If not an accordion toggle, don't interfere
      if (!accordionToggle) {
        return;
      }

      console.log('Accordion toggle clicked!', accordionToggle);

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const accordionItem = accordionToggle.closest('[data-accordion-item]');
      const accordionContent = accordionItem.querySelector('[data-accordion-content]');

      if (!accordionContent) {
        console.warn('No accordion content found for', accordionItem);
        return;
      }

      const isExpanded = accordionToggle.getAttribute('aria-expanded') === 'true';
      console.log('Is expanded:', isExpanded);

      if (isExpanded) {
        // Collapse
        console.log('Collapsing accordion');
        accordionToggle.setAttribute('aria-expanded', 'false');
        accordionContent.setAttribute('aria-hidden', 'true');
        accordionContent.style.setProperty('max-height', '0px', 'important');
        accordionItem.classList.remove('is-open');
      } else {
        // Expand
        console.log('Expanding accordion');
        accordionToggle.setAttribute('aria-expanded', 'true');
        accordionContent.setAttribute('aria-hidden', 'false');

        // Temporarily remove max-height to get true scrollHeight
        accordionContent.style.setProperty('max-height', 'none', 'important');
        const contentHeight = accordionContent.scrollHeight;
        console.log('Content scrollHeight:', contentHeight + 'px');

        // Set back to 0 briefly, then animate to full height
        accordionContent.style.setProperty('max-height', '0px', 'important');

        // Force reflow
        accordionContent.offsetHeight;

        // Now set to calculated height
        accordionContent.style.setProperty('max-height', contentHeight + 'px', 'important');
        accordionItem.classList.add('is-open');

        console.log('Set maxHeight to:', contentHeight + 'px');

        // Update parent heights if nested
        updateParentHeights(accordionItem);
      }
    }, true); // Use capture phase to intercept before theme.js

    // Update parent accordion heights when child expands
    function updateParentHeights(element) {
      let parent = element.closest('[data-accordion-content]');
      while (parent) {
        // Temporarily set to none to get real height
        parent.style.setProperty('max-height', 'none', 'important');
        const parentHeight = parent.scrollHeight;
        parent.style.setProperty('max-height', parentHeight + 'px', 'important');
        console.log('Updated parent height to:', parentHeight + 'px');
        parent = parent.parentElement.closest('[data-accordion-content]');
      }
    }

    // Handle drawer menu open event
    document.addEventListener('drawer-menu:open', function() {
      // Reset all accordions when menu opens
      const allAccordions = drawerMenu.querySelectorAll('[data-accordion-content]');
      allAccordions.forEach(function(accordion) {
        accordion.style.maxHeight = '0px';
        accordion.setAttribute('aria-hidden', 'true');
      });

      const allToggles = drawerMenu.querySelectorAll('[data-item="accordion-toggle"]');
      allToggles.forEach(function(toggle) {
        toggle.setAttribute('aria-expanded', 'false');
      });

      const allItems = drawerMenu.querySelectorAll('[data-accordion-item]');
      allItems.forEach(function(item) {
        item.classList.remove('is-open');
      });
    });

  }

  // Initialize on DOM ready - with delay to ensure theme.js loads first
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      console.log('Drawer accordion: DOM ready, initializing...');
      setTimeout(initDrawerAccordion, 500);
    });
  } else {
    console.log('Drawer accordion: DOM already loaded, initializing...');
    setTimeout(initDrawerAccordion, 500);
  }

  // Re-initialize on theme editor section load
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('[data-drawer-menu]')) {
      console.log('Drawer accordion: Section reloaded, reinitializing...');
      setTimeout(initDrawerAccordion, 500);
    }
  });

  console.log('Drawer accordion script loaded');
})();
